var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTickGreenCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 0C5.85508 0 0 5.85508 0 13C0 20.1449 5.85508 26 13 26C20.1449 26 26 20.1449 26 13C26 5.85508 20.1449 0 13 0Z",
    fill: "#97D318"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9999 13C25.9999 20.1449 20.1033 26 12.9077 26V0C20.1033 0 25.9999 5.85508 25.9999 13Z",
    fill: "#97D318"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8369 10.3749L12.9724 17.5566L11.4055 18.9929L5.71631 13.2781L7.86123 11.1236L11.4969 14.7756L12.9724 13.4309L18.7986 8.11346L20.8369 10.3749Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8368 10.3656L12.9077 17.5177V13.4091L18.7818 8.11346L20.8368 10.3656Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickGreenCircle);
export default __webpack_public_path__ + "static/media/tick_green_circle.fd18ebd79340d4e8e1c884a59b4c1cf6.svg";
export { ForwardRef as ReactComponent };